import { setLocalItem } from '../../store/localStore';
import { displayAgeFields } from './ageType';
import { BELOW_18_AGE, FAMILY_GROUP_TYPE_VALUE } from '../../../constants';
import { isControl } from '../../../utils';
export function modeTypeEventManager(form) {
    const modeTypeCards = document.querySelectorAll('.qq__card.mode-type');
    modeTypeCards.forEach((card) => {
        card.addEventListener('click', (event) => {
            // !!! START HERE
            // !!! REMOVE THIS CODE ONCE THE VARIANT WON
            if (isControl() && card.classList.contains(FAMILY_GROUP_TYPE_VALUE)) {
                showUnderEighteen();
            }
            else {
                hideUnderEighteen(form);
            }
            // !!! ENDS HERE
            modeTypeCards.forEach((card) => {
                card.classList.remove('active-card');
            });
            card.classList.add('active-card');
            card.scrollIntoView({ behavior: 'smooth', block: 'center' });
            document
                .getElementById('qq-mode-type')
                .classList.remove('error', 'required');
            const inputElement = card.querySelector('input[type="radio"]');
            if (inputElement) {
                const dataValue = inputElement.value;
                displayAgeFields(form, dataValue);
                form.set('groupType', dataValue);
                setLocalItem('groupType', dataValue); // Store in local storage
            }
            else {
                console.error('Input element not found');
            }
        });
    });
}
// !!! START HERE
// !!! REMOVE THIS CODE ONCE THE VARIANT WON
function showUnderEighteen() {
    const below18Age = document.querySelectorAll(`.${BELOW_18_AGE}`);
    if (below18Age.length > 0) {
        below18Age.forEach((childpkg) => {
            childpkg.classList.remove('hidden');
        });
    }
}
// !!! START HERE
// !!! REMOVE THIS CODE ONCE THE VARIANT WON
function hideUnderEighteen(form) {
    const below18Age = document.querySelectorAll(`.${BELOW_18_AGE}`);
    // !!! START HERE
    // !!! REMOVE THIS CODE ONCE THE VARIANT WON
    form.set('DCH', 0);
    form.set('INF', 0);
    setLocalItem('DCH', '0');
    setLocalItem('INF', '0');
    // !!! ENDS HERE
    if (below18Age.length > 0) {
        below18Age.forEach((childpkg) => {
            childpkg.classList.add('hidden');
            // !!! START HERE
            // !!! REMOVE THIS CODE ONCE THE VARIANT WON
            childpkg.querySelector('input').value = '0';
            childpkg.querySelector('.decrement-button').disabled = true;
            // !!! ENDS HERE
        });
    }
}
